import api from "../api";

const endpoint = "/api/funcionarios";
const obterTodos = async () => {
  return new Promise((resolve, reject) => {
    return api
      .get(endpoint)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterPorId = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterPorLogin = async (login) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/${login}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterFuncionariosPorLoginUsuario = async (login) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/login-usuario-logado/${login}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  obterTodos,
  obterPorId,
  obterPorLogin,
  obterFuncionariosPorLoginUsuario
};
